import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { plwebViewUrl } from "../lib/plweb";
import "./InvoiceRedirect.css";

/**
 * Where an old texted invoice link lands in a browser, e.g.
 * https://pl.eeighttech.com/invoice/INV-NF5VP
 *
 * This page used to be the invoice viewer. It is not any more — the document,
 * and the sender's offer beside it, are drawn by the web app at
 * https://plweb.eeighttech.com/view?guid=…, which is where the service's share
 * links have always pointed. This route stays only so the messages already sent
 * with the old form keep working, and so the fallback behind Android App Links
 * and iOS Universal Links has somewhere to land.
 *
 * A full-page replace rather than a router `<Navigate>`: the destination is a
 * different origin, and `replace` keeps the old form out of the back button's
 * history — going "back" to a page that only forwards is a loop.
 */
export default function InvoiceRedirect() {
	const { invoiceId } = useParams<{ invoiceId: string }>();
	const target = plwebViewUrl(invoiceId);

	useEffect(() => {
		if (target) window.location.replace(target);
	}, [target]);

	return (
		<main className="invoice-redirect">
			<p>
				{target ? (
					<>
						Opening your document… <a href={target}>Continue</a>
					</>
				) : (
					"This link is missing its document number. Open the link exactly as it was sent to you."
				)}
			</p>
		</main>
	);
}
